import { render } from "./AttendanceReport.vue?vue&type=template&id=849fde0a&scoped=true"
import script from "./AttendanceReport.vue?vue&type=script&lang=js"
export * from "./AttendanceReport.vue?vue&type=script&lang=js"

import "./AttendanceReport.vue?vue&type=style&index=0&id=849fde0a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-849fde0a"]])

export default __exports__